export default __webpack_public_path__ + "static/media/prepare-exam-background-mobile.dbb58b05.svg";